import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesStoreListComponent} from "./sales-store-list.component";
import {SalesStoreListComponentV3} from "./versions/sales-store-list-versions.component";
import {LibraryModule} from "library";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {GeneralModule} from "../general/general.module";
import {StoreIconComponent} from "../../shared/resources/store-icon/store-icon.component";

@NgModule({
  declarations: [
    SalesStoreListComponent,
    SalesStoreListComponentV3,
    StoreIconComponent
  ],
  imports: [
    CommonModule,
    LibraryModule,
    PrimengModule,
    ReactiveFormsModule,
    FormsModule,
    GeneralModule,
  ],
  exports: [
    SalesStoreListComponent,
    SalesStoreListComponentV3
  ]
})
export class SalesStoreListModule { }
